// Une rangée de chapitre : texte d'un côté, aperçu de l'autre (alternés).
import React from "react";
import { IconeCoche } from "../../site/Icones";

export default function Rangee({ surtitre, titre, texte, points = [], inverse = false, children }) {
	return (
		<div className={`gs-rangee${inverse ? " gs-rangee--inverse" : ""}`}>
			<div className="gs-rangee-texte">
				<span className="gs-surtitre">{surtitre}</span>
				<h3 className="gs-h3">{titre}</h3>
				<p className="gs-texte">{texte}</p>
				{points.length > 0 && (
					<ul className="gs-points">
						{points.map((p) => (
							<li key={p}>
								<IconeCoche taille={18} />
								<span>{p}</span>
							</li>
						))}
					</ul>
				)}
			</div>
			<div className="gs-rangee-visuel">{children}</div>
		</div>
	);
}
